<template>
  <base-loading v-if="loading" />
  <div v-else class="flex">
    <DashboardCoast
      v-if="response.costVisit"
      :data="response.costVisit"
      :start-date="form.dataInicio"
      :end-date="form.dataFim"
    />
    <v-row
      v-for="(item, index) in dashboardData"
      :key="index"
      align="center"
      justify="center"
    >
      <v-col v-if="item.chart.datasets.length > 0" cols="10">
        <h2 class="text-xl-h4 font-weight-medium" style="color: #1b2565">
          {{ item.title }}
        </h2>
        <div class="content">
          <TableGraph
            :items="item.table.items"
            :headers="item.table.headers"
            class="elevation-1"
            :disable-pagination="false"
            :hide-defaultfooter="false"
          />
          <base-line-graph
            style="height: 500px"
            :chart-data="item.chart"
            :style="styles"
            :chart-options="options"
          />
        </div>
        <v-divider :thickness="2"></v-divider>
      </v-col>

      <!-- <v-col
        v-if="dashboardData.length >= 1"
        cols="4"
        align="center"
        justify="center"
      >
        <v-btn
          style="color: white; border-radius: 8px"
          color="primary"
          @click="generateConsultorReport(data, form)"
        >
          <span style="font-size: 16px; font-weight: 600"
            ><v-icon style="margin-right: 6px">mdi-file-excel</v-icon>DOWNLOAD
            EXCEL</span
          >
        </v-btn>
      </v-col> -->
    </v-row>
  </div>
</template>

<script>
import { ENV_APP } from '../../../../env'
import api from '../../../api/api'
import { generateConsultorReport } from '../../../services/spreadsheet/ConsultorReport'
import {
  consultantDatasetGraph,
  consultantTableData,
  headerConsultantTable,
  renderConsultantDatasetGraph,
} from '../../../utils/dashboard/consultantDashboard'
// import { header } from '../../financeiro/dashboard/dashboard'
import DashboardCoast from './CostDashboard/Dashboard.vue'
import TableGraph from '../../../components/base/TableGraph.vue'

export default {
  name: 'Dashboard',

  components: {
    DashboardCoast,
    TableGraph,
  },

  props: {
    form: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      headerConsultantTable,
      loading: false,
      tabela: [],
      options: {
        indexAxis: 'y',
        barPercentage: 0.5,
        elements: {
          bar: {
            borderWidth: 2,
          },
        },
        responsive: true,
        scales: {
          xAxes: [
            {
              barThickness: 6,
              maxBarThickness: 8,
            },
          ],
        },
      },

      config: {
        indexAxis: 'y',

        elements: {
          bar: {
            borderWidth: 1,
          },
        },

        plugins: {
          legend: {},
          title: {
            display: true,
          },
        },
      },

      dashboardData: [],
      data: [],
      response: {},
      forms: null,

      styles: {
        backgroundColor: '#f1f1f1',
      },
    }
  },

  created() {},

  methods: {
    renderConsultantDatasetGraph,
    consultantDatasetGraph,
    generateConsultorReport,
    consultantTableData,

    getDashboard(form) {
      this.forms = form
      this.loading = true
      this.dashboardData = []
      api.get
        .consultantDashboard({
          projectId: ENV_APP.ProjectID,
          id: form.consultor?.length > 0 ? form.consultor : form.supervisor,
          DataInicio: form.dataInicio,
          DataFim: form.dataFim,
        })
        .then(response => {
          this.response = response.data

          let dataSet = this.getDatasetVisitasPorConsultor(response.data)

          this.dashboardData.push({
            title: 'Visita por Período',
            table: this.convertDatasetToTable(dataSet),
            chart: dataSet,
          })

          dataSet = this.getDatasetReportTypePorConsultor(response.data)

          this.dashboardData.push({
            title: 'Visita por Relatório',
            table: this.convertDatasetToTable(dataSet),
            chart: dataSet,
          })

          dataSet = this.getDatasetReportTypePorPeriodo(response.data)

          this.dashboardData.push({
            title: 'Relatório por Período',
            table: this.convertDatasetToTable(dataSet),
            chart: dataSet,
          })

          const reportType = this.extrairTiposDeRelatorio(response.data)

          reportType.forEach(type => {
            dataSet = this.getDatasetVisitasPorConsultorByType(
              response.data,
              type,
            )

            this.dashboardData.push({
              title: `${type}`,
              table: this.convertDatasetToTable(dataSet),
              chart: dataSet,
            })
          })

          this.loading = false
          // this.form.consultor = ''
        })
        .catch(error => {
          this.Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: error.message,
          })
          this.loading = false
          this.dashboardData = []
          this.data = []
          this.forms = {}
          this.form.consultor = ''
        })
    },

    extrairTiposDeRelatorio(obj) {
      const relatoriosObj = obj.visit?.metricas?.por_tipo_relatorio

      return relatoriosObj ? Object.keys(relatoriosObj) : []
    },
    convertDatasetToTable(chartDataset, labelHeaderName = 'Descrição') {
      const headers = [
        {
          text: labelHeaderName,
          value: 'label',
          fixed: true,
          width: 250,
          sortable: false,
          class: 'white--text',
        },
      ]

      // Adiciona as colunas dos meses
      chartDataset.labels.forEach(label => {
        headers.push({
          text: label,
          value: label.toLowerCase(),
          align: 'center',
          class: 'white--text',
        })
      })

      // Coluna de Total final
      headers.push({
        text: 'Total',
        value: 'total',
        align: 'center',
        class: 'white--text font-weight-bold',
      })

      const items = chartDataset.datasets.map(set => {
        const row = {
          label: set.label,
          class: '',
        }

        set.data.forEach((valor, index) => {
          const monthKey = chartDataset.labels[index].toLowerCase()
          row[monthKey] = valor || 0
        })

        row.total = chartDataset.labels.reduce((acc, label) => {
          return acc + (row[label.toLowerCase()] || 0)
        }, 0)

        return row
      })

      const totalGeral = {
        label: 'TOTAL GERAL',
        class: 'blue-row',
        total: 0,
      }

      chartDataset.labels.forEach(label => {
        const monthKey = label.toLowerCase()
        const somaColuna = items.reduce(
          (acc, row) => acc + (row[monthKey] || 0),
          0,
        )
        totalGeral[monthKey] = somaColuna
        totalGeral.total += somaColuna
      })

      items.push(totalGeral)

      return { headers, items }
    },

    getDatasetVisitasPorConsultor(data) {
      const metricasMes = data.visit.metricas.por_mes_ano

      const labels = Object.keys(metricasMes).sort((a, b) => {
        const [m1, y1] = a.split('/').map(Number)
        const [m2, y2] = b.split('/').map(Number)
        return new Date(y1, m1 - 1) - new Date(y2, m2 - 1)
      })

      const consultores = new Set()
      labels.forEach(mes => {
        Object.keys(metricasMes[mes]).forEach(nome => consultores.add(nome))
      })

      const datasets = Array.from(consultores).map(nome => {
        const color = this.getRandomColor(1)
        return {
          label: nome,
          data: labels.map(mes => metricasMes[mes][nome] || 0),
          // borderColor: this.getRandomColor(1), //'#' + Math.floor(Math.random() * 16777215).toString(16), // Cor aleatória
          // borderColor: color,
          // backgroundColor: color.replace('1)', '0.2)'),
          // tension: 0.1,
          borderColor: color,
          backgroundColor: color.replace('1)', '0.6)'),
          borderWidth: 1,
        }
      })

      return { labels, datasets }
    },

    getDatasetVisitasPorConsultorByType(data, reportName) {
      const metricasCompletas = data.visit.metricas.por_mes_relatorio_consultor

      const labels = Object.keys(metricasCompletas).sort((a, b) => {
        const [m1, y1] = a.split('/').map(Number)
        const [m2, y2] = b.split('/').map(Number)
        return new Date(y1, m1 - 1) - new Date(y2, m2 - 1)
      })

      const consultoresSet = new Set()
      labels.forEach(mes => {
        Object.keys(metricasCompletas[mes]).forEach(consultor => {
          if (metricasCompletas[mes][consultor][reportName]) {
            consultoresSet.add(consultor)
          }
        })
      })

      const datasets = Array.from(consultoresSet).map(consultor => {
        const color = this.getRandomColor(1)
        return {
          label: consultor,
          // Pega o valor do relatório X para o consultor Y no mês Z
          data: labels.map(mes => {
            return (
              (metricasCompletas[mes][consultor] &&
                metricasCompletas[mes][consultor][reportName]) ||
              0
            )
          }),
          borderColor: color,
          backgroundColor: color.replace('1)', '0.5)'),
          borderWidth: 1,
          tension: 0.1,
        }
      })

      return { labels, datasets }
    },

    getDatasetReportTypePorConsultor(data) {
      const metricasTipo = data.visit.metricas.por_tipo_relatorio

      const reportTypes = Object.keys(metricasTipo).sort(
        (a, b) => Number(a) - Number(b),
      )

      const consultoresSet = new Set()
      reportTypes.forEach(tipo => {
        Object.keys(metricasTipo[tipo]).forEach(nome =>
          consultoresSet.add(nome),
        )
      })

      const datasets = Array.from(consultoresSet).map(nomeConsultor => {
        const color = this.getRandomColor(1)
        return {
          label: nomeConsultor,
          // Para cada tipo de relatório, pegamos o valor do consultor ou 0 se não houver
          data: reportTypes.map(tipo => metricasTipo[tipo][nomeConsultor] || 0),
          // backgroundColor: this.getRandomColor(0.6), // Função de cor com opacidade
          // borderColor: this.getRandomColor(1),
          borderColor: color,
          backgroundColor: color.replace('1)', '0.6)'),
          borderWidth: 1,
        }
      })

      return {
        labels: reportTypes.map(t => `${t}`),
        datasets: datasets,
      }
    },

    getDatasetReportTypePorPeriodo(data) {
      const months = Object.keys(data.visit.metricas.por_mes_ano).sort(
        (a, b) => {
          const [mA, yA] = a.split('/').map(Number)
          const [mB, yB] = b.split('/').map(Number)
          return new Date(yA, mA - 1) - new Date(yB, mB - 1)
        },
      )

      const reportTypes = Object.keys(data.visit.metricas.por_tipo_relatorio)

      const datasets = reportTypes.map(type => {
        const color = this.getRandomColor(1)

        const dataPoints = months.map(month => {
          // Pega o objeto de dados do mês atual
          const dataInMonth = data.visit.metricas.por_mes_ano[month] || {}

          // Busca o valor real para o tipo de relatório (label) dentro desse mês
          // Se o tipo não existir no mês, retorna 0
          return dataInMonth[type] || 0
        })

        return {
          label: type,
          data: dataPoints,
          borderColor: color,
          backgroundColor: color.replace('1)', '0.6)'),
          borderWidth: 1,
          fill: false,
          tension: 0.1,
        }
      })

      return { labels: months, datasets }
    },

    getRandomColor(opacity) {
      const r = Math.floor(Math.random() * 255)
      const g = Math.floor(Math.random() * 255)
      const b = Math.floor(Math.random() * 255)
      return `rgba(${r}, ${g}, ${b}, ${opacity})`
    },

    customSort(items, sortBy, sortDesc) {
      return items.sort((a, b) => {
        const sortA = a[sortBy]
        const sortB = b[sortBy]

        if (a['agroindustria'] == 'Total') return 1

        if (sortBy == 'agroindustria') {
          if (sortDesc) return sortB.localeCompare(sortA)
          return sortA.localeCompare(sortB)
        }

        if (sortDesc[0]) return sortB - sortA

        return sortA - sortB
      })
    },
  },
}
</script>
